/* eslint-disable @typescript-eslint/no-explicit-any */
import { enableProdMode } from "@angular/core";
import { appSettings } from "./environments/app-settings";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

if (appSettings.production) {
    enableProdMode();
}

const getBrowserName = () => {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
        case agent.indexOf("edge") > -1:
            return "edge";
        case agent.indexOf("opr") > -1 && !!(window as any).opr:
            return "opera";
        case agent.indexOf("chrome") > -1 && !!(window as any).chrome:
            return "chrome";
        case agent.indexOf("trident") > -1:
            return "ie";
        case agent.indexOf("firefox") > -1:
            return "firefox";
        case agent.indexOf("safari") > -1:
            return "safari";
        default:
            return "other";
    }
};

if (getBrowserName() === "ie" || getBrowserName() === "edge") {
    document.getElementsByTagName("body")[0].innerHTML =
        '<object style=\'width:100%; height: 99%\' type="text/html" data="./browser-unsupported.html" ></object>';
} else {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
}
